<mat-toolbar class="flex-content-center">
  <span>{{ 'FooterTitle' | translate}}</span>  
</mat-toolbar>
